// extracted by mini-css-extract-plugin
module.exports = {"userGames":"UserGames_userGames__3kw5h","title":"UserGames_title__220yi","count":"UserGames_count__3ifWh","body":"UserGames_body__CWGUn","warning":"UserGames_warning__1xINX"};